var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGraphQLClientProvider } from '@portkey/graphql';
export class StorageConfig {
    constructor(storage) {
        this.storage = storage;
    }
    getItem(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.storage)
                throw new Error('Please set storage first');
            return this.storage.getItem(key);
        });
    }
    setItem(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.storage)
                throw new Error('Please set storage first');
            return this.storage.setItem(key, value);
        });
    }
    removeItem(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.storage)
                throw new Error('Please set storage first');
            return this.storage.removeItem(key);
        });
    }
    setStorage(storage) {
        this.storage = storage;
    }
}
export class ReferralConfig {
    setReferralInfo(info) {
        this.referralInfo = info;
    }
    getReferralInfo() {
        return this.referralInfo;
    }
}
export class RequestDefaultsConfig {
    constructor(config) {
        this.setConfig(config);
    }
    setConfig(config) {
        if (config) {
            Object.entries(config).forEach(([key, value]) => {
                this[key] = value;
            });
        }
    }
}
export class DIDConfig {
    constructor(options) {
        this.storageMethod = new StorageConfig();
        this.requestConfig = new RequestDefaultsConfig();
        this.connectRequestConfig = new RequestDefaultsConfig();
        this.referralConfig = new ReferralConfig();
        if (options)
            this.setConfig(options);
    }
    setConfig(options) {
        Object.entries(options).forEach(([key, value]) => {
            if (!value)
                return;
            switch (key) {
                case 'storageMethod':
                    this.storageMethod.setStorage(value);
                    break;
                case 'requestDefaults':
                    this.requestConfig.setConfig(value);
                    this.requestDefaults = value;
                    const connectRequestDefaults = Object.assign({}, value);
                    delete connectRequestDefaults.baseURL;
                    this.connectRequestConfig.setConfig(connectRequestDefaults);
                    break;
                case 'connectUrl':
                    this.connectRequestConfig.setConfig(Object.assign(Object.assign(Object.assign({}, this.requestDefaults), (options.requestDefaults || {})), { baseURL: value }));
                    break;
                case 'referralInfo':
                    this.referralConfig.setReferralInfo(value);
                    break;
                default:
                    if (key === 'graphQLUrl' && typeof value === 'string') {
                        this.graphQLClient = getGraphQLClientProvider(value);
                    }
                    this[key] = value;
                    break;
            }
        });
    }
}
